import {
  CocoReadingImageContainer,
  NpsParentFormContainer,
  ParentFormHeading,
  ParentFormSubheading,
  ParentMobileInputContainer,
  SeeYouLaterCTA,
  StyledButtonContainer
} from "./nps-parent-form.styles";
import Image from "next/legacy/image";
import CocoImage from "public/assets/nps/coco-reading-book.svg";
import { MobileInput } from "components/form-component/mobile-input/mobile-input";
import { useNpsParentForm } from "./useNpsParentForm";
import { Button } from "components/atoms/button/button";
import { Form } from "components/form-component/form/form";
import { INpsParentFormProps } from "./nps-parent-form.types";

const NpsParentForm = ({
  submitParentNumberForm,
  toggleSkipConfirmation,
  checkParentNumberIsAlreadySubmitted
}: INpsParentFormProps): JSX.Element => {
  const {
    control,
    isValid,
    handleSubmit,
    handleParentFormSubmission,
    handleSeeYouLater
  } = useNpsParentForm({
    submitParentNumberForm,
    toggleSkipConfirmation,
    checkParentNumberIsAlreadySubmitted
  });

  return (
    <Form onSubmit={handleSubmit(handleParentFormSubmission)}>
      <NpsParentFormContainer>
        <CocoReadingImageContainer>
          <Image src={CocoImage} alt="coco-image" height={144} width={144} />
        </CocoReadingImageContainer>
        <ParentFormHeading>
          Makasih! Keren deh, kamu isi waktu dengan belajar
        </ParentFormHeading>
        <ParentFormSubheading>
          CoLearn jadi mau ngenalin Kelas Live sama orangtuamu. Biar bikin
          mereka seneng 🤗
        </ParentFormSubheading>
        <ParentMobileInputContainer>
          <MobileInput
            placeholder="Ketik nomor HP di sini"
            control={control}
            label="Boleh minta no. HP orangtua?"
            name="phone_number"
          />
        </ParentMobileInputContainer>
        <StyledButtonContainer>
          <Button variant="primary" isFullWidth={true} disabled={!isValid}>
            Kirim
          </Button>
        </StyledButtonContainer>
        <SeeYouLaterCTA onClick={() => handleSeeYouLater()}>
          Ntar aja 😢
        </SeeYouLaterCTA>
      </NpsParentFormContainer>
    </Form>
  );
};

export { NpsParentForm };
